<template>
  <div class="w-full min-h-screen flex flex-col">
    <!-- Header with Logo and Account -->
    <HeaderBar :logo="logo">
      <template #account>
        <LoginDropdown />
      </template>
    </HeaderBar>
    <!-- Main Content Area -->
    <div class="flex-1 w-full">
      <div class="max-w-7xl mx-auto sm:px-6 px-3 sm:py-8 py-4">
        <!-- Stepper -->
        <div v-if="currentPage <= 3" class="mb-8">
          <div
            class="bg-white/90 backdrop-blur-md rounded-2xl shadow-lg p-8 border border-gray-100"
          >
            <StepperComponent :currentPage="currentPage" />
          </div>
        </div>

        <!-- Form Content Card -->
        <div
          class="bg-white/90 backdrop-blur-md rounded-2xl shadow-xl border border-gray-100"
        >
          <div class="p-2 sm:p-5 lg:p-12">
            <router-view />
          </div>
        </div>

        <!-- Footer -->
        <div class="mt-8 text-center">
          <p class="text-xs text-gray-500">
            Powered by VUO and Data@Elettra infrastructure © 2025
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LoginDropdown from "@/components/LoginDropdown.vue";
import StepperComponent from "@/components/StepperComponent.vue";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import HeaderBar from "@/components/HeaderBar.vue";

const logo = ref(null);
const help = ref(null);

onMounted(() => {
  logo.value = `${process.env.BASE_URL}images/enodo-logo.png`;
  help.value = `${process.env.BASE_URL}svg/help.svg`;
});

const route = useRoute();
const currentPage = computed(() => route.meta.number);
</script>
